import React, { Fragment, useCallback, useEffect, useMemo, useState, useRef } from 'react'
import { Redirect } from 'react-router-dom'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import IconButton from '@material-ui/core/IconButton'
import MmsService from 'Services/MMS/mms-api.service'
import DmsService from 'Services/DMS/dms-api.service'
import { useAuth } from 'Contexts/AuthProvider'
import { Checkbox, MenuItem, Switch } from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress'
import Fade from '@material-ui/core/Fade'
import Popover from '@material-ui/core/Popover'
import AlertToastr from 'utils/alert'
import DeleteItemModal from 'Components/modals/delete-item-modal/delete-item-modal.component'
import SaveComponentModal from './Modals/SaveComponentModal'
import ChangeDepartmentModal from './Modals/ChangeDepartmentModal'
import DuplicateComponentModal from './Modals/DuplicateComponentModal'
import ReplaceComponentModal from './Modals/ReplaceComponentModal'
import AttachComponentModal from './Modals/AttachComponentModal'
import UninstallComponentModal from './Modals/UninstallComponentModal'
import SaveActivityModal from '../Activities/Modals/SaveActivityModal'
import CloneToEquipmentModal from '../Catalog/Modals/CloneToEquipmentModal'
import {
  setComponentsCatalog,
  setCurrentPage,
  setPageTitle,
  setRspSelectedComponentsIds,
  setRunComponentsUpdate,
} from '../../../Store/modules/mms/actions'
import { connect } from 'react-redux'
import Button from '@material-ui/core/Button'
import useTranslation from 'Hooks/useTranslation'
import RecommendedSparePartsComponentBlock from './RecommendedSparePartsComponentBlock'
import CompleteActivityModal from '../Activities/Modals/CompleteActivityModal'
import { useAppSettings } from '../../../Contexts/AppSettingsProvider'
import MmsAssetsSignalR from '../../../Components/SignalrSubscribes/MmsAssetsSignalR'
import {
  buildListTreeFromFlatList,
  getDescendantIds,
  normalizeNestedToFlatList,
  upsertActivityInFlatList,
  upsertComponentsInFlatList,
} from './equipmentTreeUtils'
import { useComponentsWithPaging } from '../../../Hooks/mms/useComponents'
import { useQueryClient } from 'react-query'
import EquipmentInlineWorkhoursForm from './Modals/EquipmentInlineWorkhoursForm'
import EquipmentInlineNotesForm from './Modals/EquipmentInlineNotesForm'
import ActivitiesTable from './ActivitiesTable'
import TablePagination from './TablePagination'
import HealthCheckSettings from './Modals/HealthCheckSettings'
import SearchInput from '../../../Components/SearchInput'
import { useEmployeesByDepartmentId } from '../../../Hooks/mms/useEmployees'
import EventEmitter from '../../../utils/EventEmitter'
import { apiMmsBaseUrl } from "config";
import Api from "../../../Services/Api.service";

const descConst = 'descending'
const ascConst = 'ascending'
const arrowDownClassName = 'hasArrow'
const arrowUpClassName = 'hasArrow up'

const EquipmentComponent = props => {
  const {
    isCatalog,
    currentCompany,
    currentDepartment,
    employees,
    setCurrentPage,
    runComponentsUpdate,
    setRunComponentsUpdate,
    setComponentsCatalog,
    componentsCatalog,
    setPageTitle,
    setRspSelectedComponentsIds,
  } = props

  const { token } = useAuth()
  const [components, setComponents] = useState([])
 
  const componentsRef = useRef([])
  const stableComponentsRef = useRef([])

  const [isLoading, setIsLoading] = useState(true)
  const [isOpenNewSaveComponentModal, setIsOpenNewSaveComponentModal] = useState(false)
  const [isOpenSaveComponentModal, setIsOpenSaveComponentModal] = useState(false)
  const [isOpenCloneToEquipmentModal, setIsOpenCloneToEquipmentModal] = useState(false)
  const [parentComponentId, setParentComponentId] = useState(null)
  const [parentWorkhours, setParentWorkhours] = useState(null)
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)
  const [isOpenDeleteActivityModal, setIsOpenDeleteActivityModal] = useState(false)
  const [isOpenChangeDepartmentModal, setIsOpenChangeDepartmentModal] = useState(false)
  const [isOpenReplaceComponentModal, setIsOpenReplaceComponentModal] = useState(false)
  const [isOpenAttachComponentModal, setIsOpenAttachComponentModal] = useState(false)
  const [attachModalMode, setAttachModalMode] = useState("attach")
  const [isOpenUninstallComponentModal, setIsOpenUninstallComponentModal] = useState(false)
  const [isOpenDuplicateComponentModal, setIsOpenDuplicateComponentModal] = useState(false)
  const [isOpenSaveActivityModal, setIsOpenSaveActivityModal] = useState(false)
  const [isOpenCompleteActivityModal, setIsOpenCompleteActivityModal] = useState(false)
  const [isOpenHealthCheckSettingsModal, setIsOpenHealthCheckSettingsModal] = useState(false)
  const [menuAnchorEl, setMenuAnchorEl] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [forceUpdate, setForceUpdate] = useState(0)
  const [userClosedComponent, setUserClosedComponent] = useState(false)
  

  const [, onAnchorElChange] = useState(null)
  const [activityAnchorEl, setActivityAnchorEl] = useState(null)
  const [selectedComponent, setSelectedComponent] = useState(null)
  const [selectedComponentDetail, setSelectedComponentDetail] = useState(null)
  const [selectedActivity, setSelectedActivity] = useState(null)
  const [typeOptions, setTypeOptions] = useState([])
  const [priorityOptions, setPriorityOptions] = useState([])
  const [, setNewComponent] = useState(null);

  const { currentUser } = useAuth()
  const isSuperUser = useMemo(() => (currentUser.isSuperuser()), [currentUser])
  const isMasterUser = useMemo(() => currentUser.isMaster(), [currentUser]);
  const [openedComponentsIds, setOpenedComponentsIds] = useState([])
  const openedComponentsIdsRef = useRef([]);
  const componentsQueryKeyRef = useRef('');
  const componentsDataUpdatedAtRef = useRef(0);
  const userControlsExpansionRef = useRef(false);

  useEffect(() => {
    openedComponentsIdsRef.current = openedComponentsIds;
  }, [openedComponentsIds]);
  
  useEffect(() => {
    if (isModalOpen && openedComponentsIds.length > 0) {
      openedComponentsIdsRef.current = [...openedComponentsIds];
    }
  }, [isModalOpen, openedComponentsIds]);
  
  useEffect(() => {
    if (isModalOpen) {
      if (openedComponentsIds.length > 0) {
        openedComponentsIdsRef.current = [...openedComponentsIds];
      }
      
      if (components.length > 0) {
        frozenComponentsRef.current = JSON.parse(JSON.stringify(components));
      }
    } else {
      
      if (openedComponentsIdsRef.current.length > 0 && openedComponentsIds.length === 0 && !userClosedComponent) {
        setOpenedComponentsIds(openedComponentsIdsRef.current);
      }
      
      setUserClosedComponent(false);
      
      hasInteractedWithMenuRef.current = false;
      
      setForceUpdate(prev => prev + 1);
      
      listTreeCache.current = null;
      listTreeCacheKey.current = null;
      expandedListCache.current = null;
      expandedListCacheKey.current = null;
    }
  }, [isModalOpen, openedComponentsIds.length]);
  const [activeComponentActivity, setActiveComponentActivity] = useState(null)

  const [pageNumber, setPageNumber] = useState(1)
  const [pageSize, setPageSize] = useState(15)

  const [pagination, setPagination] = useState()
  const [searchTerm, setSearchTerm] = useState('')
  const [sortConfig, setSortConfig] = useState({ key: 'Description', direction: ascConst })

  const translation = useTranslation()
  const { appLanguage } = useAppSettings()
  const queryClient = useQueryClient()

  const [expandedIds, setExpandedIds] = useState([]);
  const [ , setIsDeleting] = useState(false);
  const [componentsOptions, setComponentsOptions] = useState([]);
  const [statesList, setStatesList] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const popoverId = open ? "state-popover" : undefined;
  const [isPopoverOpen, setPopoverOpen] = useState(false);
  const [selectedStateName, setSelectedStateName] = useState("");
  const [selectedStateId, setSelectedStateId] = useState(null);
  const [showSyncWorkhours, setShowSyncWorkhours] = useState(false);
  const [integrationType, setIntegrationType] = useState("");


  const [employeesOptions, setEmployeesOptions] = useState({ fromDepartment: [], other: [] })

  const departmentEmployees = useMemo(() => {
    if (employees && currentDepartment)
      return employees.filter(e => e.departmentId === currentDepartment.id)
    else
      return null
  }, [employees, currentDepartment])

  const closePopover = () => {
    setMenuAnchorEl(null)
    setTimeout(() => {
      componentsRef.current = [];
    }, 100);
  }

  const handleMenuClick = (e, compModel) => {
    e.preventDefault();
    e.stopPropagation();
   
    if (menuOpenRef.current || isModalOpen) {
      return;
    }
   
    if (window.isUpdatingData && hasInteractedWithMenuRef.current) {
      return;
    }
    
    if (components.length > 0) {
      frozenComponentsRef.current = JSON.parse(JSON.stringify(components));
      
      const now = Date.now();
      const lastAttachTime = window.lastAttachTime || 0;
      const timeSinceAttach = now - lastAttachTime;
      
      const lastDataUpdate = window.lastDataUpdate || 0;
      const timeSinceDataUpdate = now - lastDataUpdate;
      
      if (timeSinceAttach > 5000 && timeSinceDataUpdate > 5000) {
        hasInteractedWithMenuRef.current = true;
      }
    }
    
    setMenuAnchorEl(e.currentTarget);
    componentsRef.current = components;
    stableComponentsRef.current = components;
    const currentCompModel = compModel;
    
    const editComponentWithModel = () => editComponent(currentCompModel);
    const addSubcomponentWithModel = () => addSubcomponent(currentCompModel);
    
    window.currentMenuActions = {
      editComponent: editComponentWithModel,
      addSubcomponent: addSubcomponentWithModel,
      component: currentCompModel
    };
    
  }


  const componentList = useMemo(() => {
    return components
  }, [components])

  const listTreeCache = useRef(null);
  const listTreeCacheKey = useRef(null);
  const menuOpenRef = useRef(false);
  const frozenComponentsRef = useRef(null);
  const permanentCacheRef = useRef(null);
  const hasInteractedWithMenuRef = useRef(false);

  useEffect(() => {
    const wasOpen = menuOpenRef.current;
    const isOpen = Boolean(menuAnchorEl);
    menuOpenRef.current = isOpen;
    
    // Додаткова перевірка для уникнення проблем з ініціалізацією
    if (!wasOpen && isOpen) {
      // Меню відкрилося
      hasInteractedWithMenuRef.current = true;
    }
    
  }, [menuAnchorEl, components.length])

  useEffect(() => {
    if (isModalOpen) {
      return;
    }

    if (openedComponentsIds.length > 0) {
      openedComponentsIdsRef.current = [...openedComponentsIds];
    }
    
    listTreeCache.current = null;
    listTreeCacheKey.current = null;
    frozenComponentsRef.current = null;
    permanentCacheRef.current = null;
    hasInteractedWithMenuRef.current = false;
    stableComponentsRef.current = [];
    expandedListCache.current = null;
    expandedListCacheKey.current = null;
    componentsQueryKeyRef.current = '';
    componentsDataUpdatedAtRef.current = 0;
    userControlsExpansionRef.current = false;
    
    queryClient.removeQueries(['components', currentDepartment?.id, 'paged']);
    setComponents([]);
  }, [searchTerm, sortConfig.key, sortConfig.direction, pageNumber, pageSize, queryClient, currentDepartment?.id]);

  const listTree = useMemo(() => buildListTreeFromFlatList(components), [components]);

  const expandedListCache = useRef(null);
  const expandedListCacheKey = useRef(null);

  const expandedList = useMemo(() => {
    const filtered = listTree.filter(item =>
      item.nestingLevel === 1
      || openedComponentsIds.includes(item.id)
      || openedComponentsIds.includes(item.parentComponentId),
    )
    
    
    return filtered;
  }, [listTree, openedComponentsIds]) 

  useEffect(() => {
    const onEvent = () => {
      setIsOpenNewSaveComponentModal(true)
    }

    const listener = EventEmitter.addListener('CreateNewComponent', onEvent)
    return () => {
      listener.remove()
    }
  }, [])

  const fetchComponentOptions = async () => {
    let response = await MmsService.getComponentsWithDependencies(
      currentDepartment.id
    );
    setComponentsOptions(response.data);
  };

  const fetchComponentIntegrations = async () => {
    let response = await MmsService.getComponentsIntegrations(
    );
    if(response.data.items.length) {
      setShowSyncWorkhours(true)
    }
  };

  const fetchIntegrationType = async () => {
    if(currentCompany?.id) {
      try {
        const response = await DmsService.getIntegrations(currentCompany.id);
        if (response.status === 200 && response.data && response.data.length > 0) {
          const integrationType = response.data[0].type;
          setIntegrationType(typeof integrationType === 'string' ? integrationType : '');
        }
      } catch (error) {
        console.error('Error fetching integration type:', error);
      }
    }
  };

  useEffect(() => {
    if (currentDepartment) {
      fetchComponentOptions()
      fetchComponentIntegrations()
      fetchIntegrationType()
      if (isCatalog)
        setComponentsCatalog([])
      else
        setComponents([])
     
      hasInteractedWithMenuRef.current = false;
      menuOpenRef.current = false;
      window.isUpdatingData = false;
    }
  }, [currentDepartment, isCatalog, setComponents, setComponentsCatalog])
 

  useEffect(() => {
    isCatalog ? setPageTitle(translation.catalogPageLabel) : setPageTitle(translation.equipmentPageLabel)
  }, [setPageTitle, translation, isCatalog])

  const closeMenu = () => {
    onAnchorElChange(null)
  }

  const handleRowCount = (count) => {
    setPageSize(count)
    setPageNumber(1)
    closeMenu()
  }

  const onNextPage = () => {
    setPageNumber(p => p + 1)
    window.scrollTo(0, 0)
  }

  const onPrevPage = () => {
    setPageNumber(p => p - 1)
    window.scrollTo(0, 0)
  }

  const selectedComponentsIds = useMemo(() => {
    if (expandedList.length)
      return expandedList.filter(item => !item.parentComponentId && item.selected).map(item => item.id)
    return []
  }, [expandedList])

  useEffect(() => {
    setRspSelectedComponentsIds(selectedComponentsIds)
  }, [
    selectedComponentsIds,
    setRspSelectedComponentsIds,
  ])

  useEffect(() => {
    async function fetchComponentStates() {
      if (currentCompany?.id) {
        const componentStatesRequest = await Api.get(
          `${apiMmsBaseUrl}/options/component-states`,
          {
            headers: isSuperUser ? { CompanyId: currentCompany.id } : {},
          }
        );

        if (componentStatesRequest.data) {
          setStatesList(componentStatesRequest.data);
        }
      } else {
        const componentStatesRequest = await Api.get(
          `${apiMmsBaseUrl}/options/component-states`
        );
        if (componentStatesRequest.data) {
          setStatesList(componentStatesRequest?.data);
        }
      }
    }

    fetchComponentStates();
  }, [currentCompany?.id, isSuperUser]);

  const getStatusMessage = () => {
    const component = window.currentMenuActions?.component;
    switch (component?.state) {
      case "fieldReady":
        return "Field ready";
      case "toRepair":
        return "To repair";
      case "toCheck":
        return "To check";
      case "installed":
        return "Installed";
      case "disposed":
        return "Disposed";
      case "removed":
        return "Removed";
      default:
        return "";
    }
  };

  const handleStateListClick = (event, compModel) => {
    window.currentMenuActions = { ...window.currentMenuActions, component: compModel };
    setAnchorEl(event.currentTarget);
  };

  const handleCloseStateList = () => {
    setAnchorEl(null);
  };

  const handleClosePopover = () => {
    setPopoverOpen(false);
  };

  const handleStateItemClick = (componentId, stateId) => {
    handleCloseStateList();
    setSelectedStateId(stateId);
    setSelectedStateName(statesList.find(state => state.componentState === stateId)?.name || stateId);
    changeComponentState(componentId, stateId);
  };

  const changeComponentState = (componentId, stateId) => {
    MmsService.updateUnassignedComponentState(componentId, stateId)
      .then((res) => {
        if (res.data.isSuccessful) {
          queryClient.invalidateQueries("components");
          AlertToastr.showAlert("Component state successfully updated");
        }
      })

      .catch((error) => {
        // if (
        //   error &&
        //   error.response &&
        //   error.response.data &&
        //   error.response.data.message
        // )

        AlertToastr.showErrorAlert(
          "User is not authorized to update state component to catalog!"
        );
      });
  };

  const handleRowClicked = (compModel) => {
    if(compModel.isDeleting) {
      return
    }

    userControlsExpansionRef.current = true;
    
    setOpenedComponentsIds(prevIds => {

      if (listTree.length === 0) {
        setForceUpdate(prev => prev + 1);
        if (!compModel.parentComponentId) {
          if (prevIds.includes(compModel.id)) {
            const newIds = prevIds.filter(id => id !== compModel.id);
            return newIds;
          } else {
            const newIds = [...prevIds, compModel.id];
            return newIds;
          }
        }
        
        if (prevIds.includes(compModel.id)) {
          const newIds = prevIds.filter(id => id !== compModel.id);
          return newIds;
        } else {
          const newIds = [...prevIds, compModel.id];
          return newIds;
        }
      }
      
      const clickedItemIndex = listTree.findIndex(item => item.id === compModel.id)
      if (clickedItemIndex === -1) {
        setForceUpdate(prev => prev + 1);
        
        if (!compModel.parentComponentId) {
          if (prevIds.includes(compModel.id)) {
            const newIds = prevIds.filter(id => id !== compModel.id);
            return newIds;
          } else {
            const newIds = [...prevIds, compModel.id];
            return newIds;
          }
        }
        
        if (prevIds.includes(compModel.id)) {
          const newIds = prevIds.filter(id => id !== compModel.id);
          return newIds;
        } else {
          const newIds = [...prevIds, compModel.id];
          return newIds;
        }
      }

      const item = listTree[clickedItemIndex]

      if (prevIds.includes(item.id)) {
        if (item.nestingLevel === 1) {
          setUserClosedComponent(true);
        }

        const descendantIds = getDescendantIds(item.id, components);
        return prevIds.filter(
          (id) => id !== item.id && !descendantIds.includes(id),
        );
      }

      return [...new Set([...prevIds, item.id])];

    })
  }

    const currentDepartmentId = currentDepartment?.id;

    useEffect(() => {
        setPageNumber(1);
    }, [currentDepartmentId]);
    
    const componentsRequest = useComponentsWithPaging(currentDepartment?.id, {
    assetSortType: sortConfig.key,  //Description, Id, WorkhoursTotal, Activities, Status
    isAsc: (sortConfig.direction === ascConst),
    pageSize,
    pageNumber,
    searchTerm
    }, {
      // Prevent refetching during menu interactions
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
      keepPreviousData: false, // Don't keep previous data during search
    }) 
    
    const componentsQueryKey = `${currentDepartmentId}|${pageNumber}|${pageSize}|${searchTerm}|${sortConfig.key}|${sortConfig.direction}`;
         
    useEffect(() => {
      if (!componentsRequest.isSuccess || !componentsRequest.data) {
        return;
      }

      if (menuOpenRef.current || isModalOpen || isOpenSaveActivityModal) {
        return;
      }

      const newComponents = componentsRequest?.data?.data?.items || [];
      const isSameQuery = componentsQueryKeyRef.current === componentsQueryKey;
      const isSameData = componentsDataUpdatedAtRef.current === componentsRequest.dataUpdatedAt;

      // Skip only when both the query params and fetched data are unchanged.
      // After invalidate/refetch with the same filters, dataUpdatedAt changes and must apply.
      if (isSameQuery && isSameData && components.length > 0) {
        setIsLoading(false);
        return;
      }

      componentsQueryKeyRef.current = componentsQueryKey;
      componentsDataUpdatedAtRef.current = componentsRequest.dataUpdatedAt;
        
      setPagination({
        pageCount: componentsRequest?.data?.data?.pageCount || 0,
        itemsCount: componentsRequest?.data?.data?.itemsCount || 0,
        itemsTotalCount: componentsRequest?.data?.data?.itemsTotalCount || 0,
        pageNumber: componentsRequest?.data?.data?.pageNumber || 0,
        pageSize: componentsRequest?.data?.data?.pageSize || 0,
      });
          
      const flatComponents = normalizeNestedToFlatList(newComponents);
      setComponents(flatComponents);

      if (flatComponents.length > 0) {
        stableComponentsRef.current = JSON.parse(JSON.stringify(flatComponents));
      }
          
      setIsLoading(false);
          
      const responseExpandedIds = componentsRequest?.data?.data?.expandedIds || [];

      if (!userControlsExpansionRef.current && responseExpandedIds.length > 0) {
        setOpenedComponentsIds(responseExpandedIds);
      }
    }, [
      componentsRequest.isSuccess,
      componentsRequest.data,
      componentsRequest.dataUpdatedAt,
      componentsQueryKey,
      components.length,
      isModalOpen,
      isOpenSaveActivityModal,
      setComponents,
    ])

  useEffect(() => {
    if (!isOpenSaveActivityModal) {
      return;
    }

    if (window.currentMenuActions?.component) {
      setSelectedComponentDetail(window.currentMenuActions.component);
    }
  }, [isOpenSaveActivityModal]);

  useEffect(() => {
    const fetchComponentsCatalog = async () => {
      try {
        const response = await MmsService.getComponentsCatalog()
        setComponentsCatalog(response.data)
        setIsLoading(false)
      } catch (error) {
        setIsLoading(false)
        if (error && error.response && error.response.data && error.response.data.message)
          AlertToastr.showErrorAlert(error.response.data.message)
      }
    }
    if (isCatalog) {
      setCurrentPage('components')
      setIsLoading(true)
      fetchComponentsCatalog()
    } else {
      setCurrentPage('equipment')
      if (!currentDepartment)
        return
      // fetchComponents();
    }
  }, [
    setComponents,
    currentCompany,
    isSuperUser,
    currentDepartment,
    setCurrentPage,
    runComponentsUpdate,
    isCatalog,
    setComponentsCatalog
  ])
  
  useEffect(() => {
    const fetchOptions = async () => {
      let typeResponse = await MmsService.getTypesOptions(appLanguage)
      setTypeOptions(typeResponse.data)
      let priorityResponse = await MmsService.getPriorityOptions(appLanguage)
      setPriorityOptions(priorityResponse.data)
    }
    fetchOptions()
  }, [appLanguage])

  const onDeleteComponent = () => {
    setIsDeleting(true);
    MmsService.deleteComponent(window.currentMenuActions?.component?.id).then(res => {
      if (res.data.isSuccessful) {
        if(res.data.expandedIds.length > 0) {
          setExpandedIds(res.data.expandedIds); 
        } else {
          setExpandedIds(openedComponentsIds)  
        } 
        AlertToastr.showAlert(res.data.message)
        if(res.data.message === "Asset removal successfully started") {
          setOpenedComponentsIds([]);
          setExpandedIds([]);
          setSelectedComponentDetail(null)
          setSelectedComponent(null)
        }
        queryClient.invalidateQueries(['components']).then()
        if(res.data.item.state === "removed") {
          // AlertToastr.showAlert(translation.notificationsComponentDeleted)
        } else {
          AlertToastr.showAlert(translation.notificationsAssetDeleted)
        }
        // setIsDeleting(false);
        queryClient.invalidateQueries(['components']).then()
        setRunComponentsUpdate(Math.random())
        setSelectedComponent(null)
      }
    })
      .catch((error) => {
        if (error && error.response && error.response.data && error.response.data.message)
          AlertToastr.showErrorAlert(error.response.data.message)
      })
      setIsDeleting(false);
      setSelectedComponent(null)
      setSelectedComponentDetail(null)
  }

  const requestSort = (key) => {
    let direction = ascConst
    if (
      sortConfig &&
      sortConfig.key === key &&
      sortConfig.direction === ascConst
    ) {
      direction = descConst
    }
    setSortConfig({ key, direction })
  }

  const getClassNamesFor = (name) => {
    if (!sortConfig || sortConfig.key !== name) {
      return
    }
    if (sortConfig.direction)
      return sortConfig.direction === ascConst ? arrowDownClassName : arrowUpClassName
  }

  const onDeleteActivity = () => {
    MmsService.deleteActivity(selectedActivity.id).then(res => {
      if (res.data.isSuccessful) {
        AlertToastr.showAlert(translation.notificationsActivityDeleted)
        queryClient.invalidateQueries(['components']).then()
        setExpandedIds(res.data.expandedIds);
        if (isCatalog) {
          const componentIndex = componentsCatalog.findIndex(c => c.id === window.currentMenuActions?.component?.id)
          const newActivities = [...componentsCatalog[componentIndex].activities]
          const activityindex = newActivities.findIndex(a => a.id === selectedActivity.id)
          newActivities.splice(activityindex, 1)
          componentsCatalog.splice(componentIndex, 1, {
            ...componentsCatalog[componentIndex],
            activities: [...newActivities],
          })
          setComponentsCatalog([...componentsCatalog])
          queryClient.invalidateQueries(['components']).then()
          setExpandedIds(res.data.expandedIds);
        } else {
          const componentIndex = components.findIndex(c => c.id === window.currentMenuActions?.component?.id)
          const newActivities = [...components[componentIndex].activities]
          const activityindex = newActivities.findIndex(a => a.id === selectedActivity.id)
          newActivities.splice(activityindex, 1)
          components.splice(componentIndex, 1, {
            ...components[componentIndex],
            activities: [...newActivities],
          })
          setComponents([...components])
          queryClient.invalidateQueries(['components']).then()
          setExpandedIds(res.data.expandedIds);
        }
      }
    })
      .catch((error) => {
        if (error && error.response && error.response.data && error.response.data.message)
          AlertToastr.showErrorAlert(error.response.data.message)
      })
  }

  const addSubcomponent = (component) => {
    setSelectedComponent(null)
    setSelectedComponentDetail(null)
    closePopover()
    setParentComponentId(component.id)
    setParentWorkhours(component.workhoursTotal)
    setIsModalOpen(true)
    setIsOpenSaveComponentModal(true)
    setNewComponent({ parentComponentId: component.id });
  }

  const editComponent = (component) => {
    const parentComponent = components.find(c => c.id === component.parentComponentId)
    setParentWorkhours(parentComponent ? parentComponent.workhoursTotal : 0)
    closePopover()
    setSelectedComponentDetail(null)
    
    setIsModalOpen(true)
    setIsOpenSaveComponentModal(true)
  }

  const handleSelectedIdChange = (componentId, checked) => {
    components.find(c => c.id === componentId).selected = checked
    if (isCatalog)
      setComponentsCatalog([...componentList])
    else
      setComponents([...components])
  }

  const handleSuccessSave = (newComponent) => {
    if (!newComponent) {
      return;
    }

    const flatNewComponents = normalizeNestedToFlatList([newComponent]);

    setOpenedComponentsIds((prevIds) => (
      [...new Set([...prevIds, ...flatNewComponents.map((component) => component.id)])]
    ));

    setComponents((prevComponents) => {
      const updated = upsertComponentsInFlatList(prevComponents, flatNewComponents);
      stableComponentsRef.current = JSON.parse(JSON.stringify(updated));
      return updated;
    });
    setNewComponent(null);
    window.currentMenuActions = null;
    componentsRef.current = [];
  };

  const handleAllSelectedChange = (checked) => {
    const newComponents = components.map(c => { 
      if (!c.parentComponentId)
        c.selected = checked
      return c
    })
    if (isCatalog)
      setComponentsCatalog([...newComponents])
    else
      setComponents([...newComponents])
  }

  const handleSelectedShowActivityChange = (componentId) => {
    setActiveComponentActivity(prevComponentId => prevComponentId === componentId ? null : componentId)
  }

  const handleActivitySaved = useCallback((activityData, componentId) => {
    hasInteractedWithMenuRef.current = false;
    frozenComponentsRef.current = null;
    permanentCacheRef.current = null;

    if (!activityData || !componentId) {
      return;
    }

    setComponents((prevComponents) => {
      const updated = upsertActivityInFlatList(prevComponents, componentId, activityData);
      stableComponentsRef.current = JSON.parse(JSON.stringify(updated));
      return updated;
    });
  }, [setComponents]);

  const handleIsActiveChanged = (checked) => {
    const component = window.currentMenuActions?.component;
    if (!component) return;
    
    component.isActive = checked
    MmsService.setComponentActivity(component.id, checked).then((response) => {
      if (response.data.isSuccessful) {
        components.find(c => c.id === component.id).isActive = checked 
        if (isCatalog)
          setComponentsCatalog([...componentList])
        else
          setComponents([...components]) 
      }
    })
      .catch((error) => {
        component.isActive = !checked
        if (error && error.response && error.response.data && error.response.data.message)
          AlertToastr.showErrorAlert(error.response.data.message)
      })
  }

     const handleLiveData = useCallback((data) => {
     const {componentId, workhours} = data;
     
     if (menuOpenRef.current || isModalOpen) {
       return;
     }
     
    //  setComponents(prev => {
    //    const existingComponent = prev.find(c => c.id === componentId);
    //    if (existingComponent && existingComponent.workhoursTotal === workhours) {
    //      return prev; 
    //    }
       
    //    const newComponents = JSON.parse(JSON.stringify(prev));
    //    newComponents.forEach(component => {
    //      setWorkhoursSubcomponents(component, data)
    //    });
    //    return newComponents.map(component => component.id === componentId ? {...component, workhoursTotal: workhours} : {...component})
    //  })
   }, [isModalOpen])
  
  const setWorkhoursSubcomponents = (component, data) => {
    const {componentId, workhours} = data;
    if (component.id === componentId) {
      component.workhoursTotal = workhours;
      return;
    } else {
      component.subComponents.forEach(subComponent => {
        setWorkhoursSubcomponents(subComponent, data);
      });
    }
  }

  const updateList = useCallback(() => {
    if (menuOpenRef.current || isModalOpen) {
      return;
    }
   
    if (!currentDepartment?.id) {
      return;
    }
    
    if (!hasInteractedWithMenuRef.current) {
      window.isUpdatingData = false;
    } else {
      window.isUpdatingData = true;
      window.lastDataUpdate = Date.now();
    }
    
    const departmentId = currentDepartment?.id;
    
    frozenComponentsRef.current = null;
    permanentCacheRef.current = null;
    listTreeCache.current = null;
    listTreeCacheKey.current = null;
    expandedListCache.current = null;
    expandedListCacheKey.current = null;
    stableComponentsRef.current = [];
    hasInteractedWithMenuRef.current = false;
    componentsQueryKeyRef.current = '';
    componentsDataUpdatedAtRef.current = 0;
  
    queryClient.invalidateQueries(['components', departmentId, 'paged'], { exact: false })
      .then(() => {
        setTimeout(() => {
          window.isUpdatingData = false;
        }, 3000);
      })
      .catch((error) => {
        console.error('Error refetching components:', error);
        window.isUpdatingData = false;
      });
  }, [queryClient, isModalOpen, currentDepartment?.id])

  
  useEffect(() => {
    if (currentDepartment) {
      
      frozenComponentsRef.current = null;
      permanentCacheRef.current = null;
      listTreeCache.current = null;
      listTreeCacheKey.current = null;
      expandedListCache.current = null;
      expandedListCacheKey.current = null;
      hasInteractedWithMenuRef.current = false;
      
      
      updateList()
    }
  }, [currentDepartment, updateList])

  const employeesByDepartmentIdRequest = useEmployeesByDepartmentId(currentDepartment?.id)

  useEffect(() => {
    if (employeesByDepartmentIdRequest.isSuccess) {
      setEmployeesOptions(employeesByDepartmentIdRequest.data.data)
    }
  }, [
    employeesByDepartmentIdRequest.isSuccess, employeesByDepartmentIdRequest.data
  ])

  const renderEmptyListText = () => {
    if (components.length || isLoading) return null
    return (
      <div className="emptyInfoHolder">
        <p className="textGray text-center">{translation.activitiesPagePartsEmptyListPlaceholderLabel}</p>
      </div>
    )
  }

  if (!isSuperUser && isCatalog)
    return <Redirect to="/companies"/>  

  return (
    <>
      <div className="searchBar">
        <SearchInput
          search={searchTerm}
          onChange={setSearchTerm}
          id="assetsSearchField"
        />
        <div className='searchBarMessage'>{componentsRequest.data?.data?.message}</div>
      </div>
      <div className="pmTableHolder">
        <table className="pmTable">
          <thead>
            <tr>
              <th className="checkBoxCell">
                <Checkbox
                  checked={
                    componentList
                      ? componentList
                          .filter((c) => !c?.parentComponentId)
                          .every((c) => c.selected)
                      : false
                  }
                  onChange={(e) => handleAllSelectedChange(e.target.checked)}
                  color="default"
                  id="assetsTblCheckBoxAllRows"
                  size="small"
                />
              </th>
              <th
                onClick={() => requestSort("Description")}
                className={getClassNamesFor("Description")}
                id="assetsTblHeaderDescription"
              >
                {translation.equipmentPageMyEquipmentNameHeader}
              </th>
              <th
                onClick={() => requestSort("Id")}
                className={getClassNamesFor("Id")}
                id="assetsTblHeaderID"
              >
                {translation.equipmentPageMyEquipmentIdHeader}
              </th>
              {(isMasterUser || isSuperUser) && (
                <th id="assetsTblHeaderAssetType">
                  {translation.assetType}
                </th>
              )}
              {components.length > 0 &&
              expandedList.some(
                (compModel) => compModel.uId && compModel.uId.length > 0
              ) ? (
                <th
                  onClick={() => requestSort("SerialNumber")}
                  // className={`${getClassNamesFor(
                  //   "SerialNumber"
                  // )} slide-in-from-left`}
                  id="assetsTblHeaderSerialNumber"
                >
                  {translation.equipmentPageMyEquipmentSerialNumberHeader}
                </th>
              ) : (
                <th></th>
              )}
              <th
                onClick={() => requestSort("Note")}
                className={getClassNamesFor("Note")}
                id="assetsTblHeaderNote"
              >
                {translation.equipmentPageMyEquipmentNoteHeader}
              </th>
              {isCatalog && (
                <th
                  onClick={() => requestSort("manufacturerName")}
                  className={getClassNamesFor("manufacturerName")}
                >
                  {translation.equipmentPageMyEquipmentManufacturerHeader}
                </th>
              )}
              {!isCatalog && (
                <th
                  onClick={() => requestSort("WorkhoursTotal")}
                  className={getClassNamesFor("WorkhoursTotal")}
                  id="assetsTblHeaderWorkhours"
                >
                  {translation.equipmentPageMyEquipmentWorkhoursTotalHeader}
                </th>
              )}
              <th
                onClick={() => requestSort("Activities")}
                className={getClassNamesFor("Activities")}
                id="assetsTblHeaderActivities"
              >
                {translation.equipmentPageMyEquipmentActivitiesHeader}
              </th>
              {/* <th
                colSpan="2"
                style={{ textAlign: "right" }}
                onClick={() => requestSort("Status")}
                className={getClassNamesFor("Status")}
                id="assetsTblHeaderOperationalStatus"
              >
                {translation.equipmentPageMyEquipmentStatusHeader}
              </th> */}
               <th
                      onClick={() => requestSort("State")}
                      className={getClassNamesFor("State")}
                    >
                      {translation.unassignedComponentsPageStateHeader}
                    </th>
            </tr>
          </thead>
          <tbody>
            {components.length > 0
              ? expandedList.map((compModel, index) => {
                  return (
                    <Fragment key={compModel.id || `component-${index}`}>
                      <tr
                        className={
                          compModel.parentComponentId ? "innerRow" : "" 
                        }
                      >
                        <td className="checkBoxCell">
                          {!compModel.parentComponentId && (
                            <Checkbox
                              checked={
                                compModel.selected ? compModel.selected : false
                              }
                              id="assetsTblCheckBoxAsset"
                              disabled={compModel.isDeleting}
                              className={compModel.isDeleting ? 'deletedDepartment' : ''}
                              onChange={(e) =>
                                handleSelectedIdChange(
                                  compModel.id,
                                  e.target.checked
                                )
                              }
                              color="default"
                              size="small"
                            />
                          )}
                        </td>
                        <td
                          className={compModel.isDeleting ? 'deletedDepartment' : 'text-semi-bold'}
                          onClick={() => handleRowClicked(compModel)}
                          style={{minWidth: "240px"}}
                        >
                          {compModel.parentComponentId && (
                            <div
                              className='hasInnerRowIcon slide-in-from-top'
                              style={{
                                paddingLeft: compModel.nestingLevel === 2 ? 0 : compModel.nestingLevel * 8,
                              }}
                            >
                              <div  className='icoInnerRow'/>
                              <div className="caption">
                                {`${compModel.name}`}
                              </div>
                            </div>
                          )}
                          {!compModel.parentComponentId && `${compModel.name} `}
                        </td>
                        <td style={{minWidth: "180px"}} onClick={() => handleRowClicked(compModel)} className={compModel.isDeleting ? 'deletedDepartment' : ''}>
                          {compModel.number}
                        </td>
                        {(isMasterUser || isSuperUser) && (
                          <td onClick={() => handleRowClicked(compModel)} style={{minWidth: "180px"}} className={compModel.isDeleting ? 'deletedDepartment' : ''}>
                            {compModel.assetTypeName || ''}
                          </td>
                        )}
                        {compModel.uId ? (
                          <td onClick={() => handleRowClicked(compModel)} style={{minWidth: "180px"}}>
                            <div className={compModel.isDeleting ? 'deletedDepartment' : ''}>
                              {compModel.uId}
                            </div>
                          </td>
                        ) : (
                          <td></td>
                        )}
                        <td className={compModel.isDeleting ? 'deletedDepartment pr10' : 'pr10'} style={{minWidth: "180px"}}>
                          {!compModel.parentComponentId ? (
                            <EquipmentInlineNotesForm
                              model={compModel}
                              onSuccessUpdate={() => {
                                queryClient
                                  .invalidateQueries(["components"])
                                  .then();
                              }}
                            />
                          ) : (
                            <>&nbsp;</>
                          )}
                        </td>
                        {!isCatalog && (
                          <td className={compModel.isDeleting ? 'deletedDepartment pr10' : 'pr10'} style={{minWidth: "150px"}}>
                            <EquipmentInlineWorkhoursForm
                              setExpandedIds={setExpandedIds}
                              openedComponentsIds={openedComponentsIds}
                              disabled={compModel.isDeleting}
                              model={compModel}
                              onSuccessUpdate={() => {
                                queryClient
                                  .invalidateQueries(["components"])
                                  .then();
                              }}
                              showSyncWorkhours={showSyncWorkhours}
                              integrationType={integrationType}
                            />
                          </td>
                        )}
                        {isCatalog && (
                          <td
                            onClick={() => handleRowClicked(compModel)}
                            className={compModel.isDeleting ? 'deletedDepartment pr10' : 'pr10'}
                            style={{minWidth: "200px"}}
                          >
                            {compModel.manufacturerName}
                          </td>
                        )}
                        <td className={compModel.isDeleting ? 'deletedDepartment textBtnCell' : 'textBtnCell'} style={{minWidth: "150px"}}>
                          <Button
                            className="activitiesItem"
                            disabled={compModel.isDeleting}
                            id="assetsTblActivityShowMenuBtn"
                            onClick={() =>
                              handleSelectedShowActivityChange(compModel.id)
                            }
                          >{`${
                            translation.equipmentPageMyEquipmentActivitiesLabel
                          } (${
                            compModel.activities
                              ? compModel.activities.length
                              : 0
                          })`}</Button>
                        </td>
                        {/* {!compModel.parentComponentId && (
                          <td onClick={() => handleRowClicked(compModel)} className={compModel.isDeleting ? 'deletedDepartment' : ''}>
                            {compModel.isActive && (
                              <div className="statusItem on">
                                {
                                  translation.equipmentPageMyEquipmentStatusLabelActive
                                }
                              </div>
                            )}
                            {!compModel.isActive && (
                              <div className="statusItem off">
                                {
                                  translation.equipmentPageMyEquipmentStatusLabelInActive
                                }
                              </div>
                            )}
                          </td>
                        )} */}
                        {!compModel.parentComponentId ? (
                                <td
                                  className={
                                    compModel.isDeleting
                                      ? 'deletedDepartment p0"'
                                      : "p0"
                                  }
                                >
                                  {!compModel.isActive ? (
                                       <div className="statusItem off" style={{textAlign: 'left'}}>
                                       {
                                         translation.equipmentPageMyEquipmentStatusLabelInActive
                                       }
                                     </div>
                                  ) : (
                                      <Button
                                          onClick={(event) => handleStateListClick(event, compModel)}
                                          aria-describedby={popoverId}
                                          id="ucTblShowStatesBtn"
                                          disabled={compModel.parentComponentId || compModel.isDeleting}
                                          className={
                                              compModel.parentComponentId
                                                  ? `state-item ${compModel.state}`
                                                  : `state-item-table ${compModel.state}`
                                          }
                                      >
                                          {statesList.find((stateObj) => stateObj.componentState === compModel.state)?.name || compModel.state}
                                      </Button>
                                  )}
                                  <Popover
                                    id={popoverId}
                                    classes={{
                                      paper: "statePopover",
                                    }}
                                    open={open}
                                    anchorEl={anchorEl}
                                    onClose={handleCloseStateList}
                                    anchorOrigin={{
                                      vertical: "bottom",
                                      horizontal: "left",
                                    }}
                                    transformOrigin={{
                                      vertical: "top",
                                      horizontal: "left",
                                    }}
                                  >
                                    {statesList
                                      .filter(state => state.componentState !== 'disposed')
                                      .map((state, index) => (
                                        <MenuItem
                                          key={index}
                                          id="ucTblChooseStatesBtn"
                                          onClick={() => {
                                            handleClosePopover();
                                                handleStateItemClick(
            window.currentMenuActions?.component?.id,
            state.componentState
          );
                                          }}
                                          className={`state-item ${state.componentState} mb16`}
                                        >
                                          {state.name}
                                        </MenuItem>
                                    ))}
                                  </Popover>
                                </td>
                              ) : (
                                null
                              )}
                        {compModel.parentComponentId && <td></td>}
                        <td className={compModel.isDeleting ? 'deletedDepartment btnCell' : 'btnCell'}>
                          <IconButton
                            aria-label="delete"
                            disabled={compModel.isDeleting}
                            size="small"
                            className="dropDownBtn mobile"
                            id="assetsTblDropDownBtn"
                            onClick={(e) => handleMenuClick(e, compModel)}
                          >
                            <MoreVertIcon />
                          </IconButton>
                        </td>
                      </tr>
                      {compModel.id === activeComponentActivity && (
                        <tr className="activitiesRow">
                          <td colSpan="100" className="activitiesRowContent" style={{
                                paddingLeft: compModel.nestingLevel * 25,
                              }}>
                            <ActivitiesTable
                              activities={compModel.activities}
                              disabled={compModel.isDeleting}
                              typeOptions={typeOptions}
                              priorityOptions={priorityOptions}
                              setExpandedIds={setExpandedIds}
                              onAddActivity={() => {
                                if (!isSuperUser && isCatalog) return;
                                window.currentMenuActions = { ...window.currentMenuActions, component: compModel };
                                setIsOpenSaveActivityModal(true);
                                setSelectedActivity(null);
                              }}
                              onEditActivity={(e, activity) => {
                                setActivityAnchorEl(e.target);
                                setSelectedActivity(activity);
                                window.currentMenuActions = { ...window.currentMenuActions, component: compModel };
                              }}
                              disableAdd={!isSuperUser && isCatalog}
                              compModel={compModel}
                            />
                          </td>
                        </tr>
                      )}
                    </Fragment>
                  );
                })
              : null}
          </tbody>
        </table>
        {renderEmptyListText()}
        {isLoading ? (
          <div className="loaderHolder">
            <Fade in={isLoading} unmountOnExit>
              <CircularProgress />
            </Fade>
          </div>
        ) : null}
      </div>
      {components && components.length > 0 && (
        <TablePagination
          pagination={pagination}
          onPrevPage={onPrevPage}
          onNextPage={onNextPage}
          handleRowCount={handleRowCount}
          loading={componentsRequest.isLoading}
        />
      )}
      <Popover
        anchorEl={menuAnchorEl}
        keepMounted
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        disableScrollLock={true}
        open={Boolean(menuAnchorEl)}
        onClose={closePopover}
        className="pmPopover equipmentSubMenu"
      >
        {(isSuperUser || !isCatalog) &&
          window.currentMenuActions?.component &&
          !window.currentMenuActions?.component?.parentComponentId && (
            <div className="reverseSwitchHolder">
              <Switch
                checked={Boolean(
                  window.currentMenuActions?.component ? window.currentMenuActions.component.isActive : false
                )}
                onChange={(e) => handleIsActiveChanged(e.target.checked)}
                color="primary"
                id="assetsTblMenuActiveBtn"
              />
              <div>{translation.popoverActiveLabel}</div>
            </div>
          )}
        {(isSuperUser || !isCatalog) && (
          <MenuItem
            key={"add"}
            onClick={() => window.currentMenuActions?.addSubcomponent()}
            className="menuItem add"
            id="assetsTblMenuAddComponentBtn"
          >
            {!window.currentMenuActions?.component?.parentComponentId
              ? translation.popoverAddComponentLabel
              : translation.popoverAddSubcomponentLabel}
          </MenuItem>
        )}
        {(isSuperUser || !isCatalog) && (
          <MenuItem
            key={"edit"}
            onClick={() => window.currentMenuActions?.editComponent()}
            className="menuItem edit"
            id="assetsTblMenuDetailsBtn"
          >
            {translation.popoverDetailsLabel}
          </MenuItem>
        )}
        {!isCatalog &&
          window.currentMenuActions?.component &&
          !window.currentMenuActions?.component?.parentComponentId && (
            <MenuItem
              key={"duplicate"}
              onClick={() => {
                setSelectedComponentDetail(window.currentMenuActions?.component);
                setIsOpenNewSaveComponentModal(true);
                // setIsOpenDuplicateComponentModal(true)
                closePopover();
              }}
              id="assetsTblMenuDublicateBtn"
              className="menuItem duplicate"
            >
              {translation.popoverDuplicateLabel}
            </MenuItem>
          )}
        {!isCatalog &&
          window.currentMenuActions?.component &&
          !window.currentMenuActions?.component?.parentComponentId && (
            <MenuItem
              key={"change"}
              id="assetsTblMenuChangeDepBtn"
              onClick={() => {
                setIsOpenChangeDepartmentModal(true);
                closePopover();
              }}
              className="menuItem changeDepartment"
            >
              {translation.popoverChangeDepartmentLabel}
            </MenuItem>
          )}
        {!isCatalog &&
          window.currentMenuActions?.component &&
          window.currentMenuActions?.component?.parentComponentId && (
            <MenuItem
              key={"replace"}
              id="assetsTblMenuReplaceModalBtn"
              onClick={() => {
                setIsOpenReplaceComponentModal(true);
                closePopover();
              }}
              className="menuItem replace"
            >
              {translation.popoverReplaceLabel}
            </MenuItem>
          )}
          {!isCatalog &&
          window.currentMenuActions?.component &&
          !window.currentMenuActions?.component?.parentComponentId && (
            <MenuItem
              key={"attach"}
              id="assetsTblMenuAttachModalBtn"
              onClick={() => {
                setAttachModalMode("attach");
                setIsOpenAttachComponentModal(true);
                closePopover();
              }}
              className="menuItem attach"
            >
              {translation.popoverAttachToLabel}
            </MenuItem>
          )}
        {!isCatalog &&
          window.currentMenuActions?.component &&
          window.currentMenuActions?.component?.parentComponentId && (
            <MenuItem
              key={"detach"}
              id="assetsTblMenuDetachModalBtn"
              onClick={() => {
                setAttachModalMode("detach");
                setIsOpenAttachComponentModal(true);
                closePopover();
              }}
              className="menuItem detach"
            >
              {translation.popoverDetachFromLabel}
            </MenuItem>
          )}      
        {!isCatalog &&
          window.currentMenuActions?.component &&
          window.currentMenuActions?.component?.parentComponentId && (
            <MenuItem
              key={"uninstall"}
              id="assetsTblMenuUninstallModalBtn"
              onClick={() => {
                setIsOpenUninstallComponentModal(true);
                closePopover();
              }}
              className="menuItem uninstall"
            >
              {translation.popoverUninstallLabel}
            </MenuItem>
          )}     
        {!isCatalog &&
          window.currentMenuActions?.component &&
          // !window.currentMenuActions?.component?.parentComponentId &&
          // window.currentMenuActions?.component?.assetTypeId != null &&
          // window.currentMenuActions?.component?.dmsUnitUId != null && 
          (isSuperUser || isMasterUser) &&
          (
            <MenuItem
              key={"healthCheck"}
              onClick={() => {
                setIsOpenHealthCheckSettingsModal(true);
                closePopover();
              }}
              id="assetsTblMenuHealthCheckBtn"
              className="menuItem healthCheck"
            >
              Health check settings
            </MenuItem>
          )}
        {(isSuperUser || !isCatalog) && (
          <MenuItem
            key={"delete"}
            onClick={() => {
              setIsOpenDeleteModal(true);
              closePopover();
            }}
            id="assetsTblMenuRemoveBtn"
            className="menuItem delete"
          >
            {translation.popoverRemoveLabel}
          </MenuItem>
        )}
        {!isSuperUser && isCatalog && (
          <>
            <MenuItem
              key={"take"}
              onClick={() => {
                setIsOpenCloneToEquipmentModal(true);
                closePopover();
              }}
              className="menuItem change"
            >
              {translation.popoverTakeToMyEquipmentLabel}
            </MenuItem>
            <MenuItem
              key={"show"}
              onClick={() => editComponent(window.currentMenuActions?.component)}
              className="menuItem edit"
            >
              {translation.popoverShowDetailsLabel}
            </MenuItem>
          </>
        )}
      </Popover>
      <Popover
        anchorEl={activityAnchorEl}
        id="assetsTblActivitySideMenuBtn"
        keepMounted
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        disableScrollLock={true}
        open={Boolean(activityAnchorEl)}
        onClose={() => setActivityAnchorEl(null)}
        className="pmPopover equipmentSubMenu"
      >
        <MenuItem
          disabled={selectedActivity && selectedActivity.status !== "opened"}
          key={"edit"}
          id="assetsTblActivitySideMenuDetailsBtn"
          onClick={() => {
            setActivityAnchorEl(null);
            setIsOpenSaveActivityModal(true);
          }}
          className="menuItem edit"
        >
          {translation.popoverDetailsLabel}
        </MenuItem>
        <MenuItem
          key={"delete"}
          id="assetsTblActivitySideMenuRemoveBtn"
          onClick={() => {
            setIsOpenDeleteActivityModal(true);
            setActivityAnchorEl(null);
          }}
          className="menuItem delete"
        >
          {translation.popoverRemoveLabel}
        </MenuItem>
      </Popover>

      <SaveComponentModal
        open={isOpenNewSaveComponentModal}
        handleClose={(e) => {
          setSelectedComponent(null);
          setSelectedComponentDetail(null);
          setIsOpenNewSaveComponentModal(false);
          setIsOpenSaveComponentModal(false);
        }}
        isCatalog={false}
        duplicateBasedOnComponent={selectedComponentDetail}
        onSuccessSave={handleSuccessSave}
        parentComponentId={selectedComponentDetail?.parentComponentId}
        openedComponentsIds={openedComponentsIds}
        setExpandedIds={setExpandedIds}
        showSyncWorkhours={showSyncWorkhours}
      />

      <SaveComponentModal
        open={isOpenSaveComponentModal}
        handleClose={() => {
          setParentComponentId(null);
          // setParentWorkhours(0);
          setSelectedComponent(null);
          setSelectedComponentDetail(null);
          // setNewComponent(null);
          window.currentMenuActions = null;
          componentsRef.current = [];
          setIsModalOpen(false)
          setIsOpenSaveComponentModal(false);
          setIsOpenNewSaveComponentModal(false);
        }}
        component={window.currentMenuActions?.component && !parentComponentId ? window.currentMenuActions.component : null}
        parentComponentId={parentComponentId}
        parentWorkhours={parentWorkhours}
        isCatalog={isCatalog}
        isReadOnly={!isSuperUser && isCatalog}
        loading={false}
        onSuccessSave={handleSuccessSave}
        setExpandedIds={setExpandedIds}
        showSyncWorkhours={showSyncWorkhours}
        disableCacheInvalidation={true}
      />
      <ChangeDepartmentModal
        open={isOpenChangeDepartmentModal}
        handleClose={() => setIsOpenChangeDepartmentModal(false)}
        department={currentDepartment}
        componentIds={[window.currentMenuActions?.component?.id]}
        onSuccessChange={updateList}
      />
      <DuplicateComponentModal
        parentComponentId={window.currentMenuActions?.component?.parentComponentId}
        isOpen={isOpenDuplicateComponentModal}
        isOpenManager={setIsOpenDuplicateComponentModal}
        componentIds={[window.currentMenuActions?.component?.id]}
        departmentId={currentDepartment?.id}
        isCatalog={isCatalog}
        onSuccessDuplicate={updateList}
      />
      <ReplaceComponentModal
        componentIds={[window.currentMenuActions?.component?.id]}
        isOpen={isOpenReplaceComponentModal}
        isOpenManager={setIsOpenReplaceComponentModal}
        handleClose={() => {
          setIsOpenReplaceComponentModal(false);
          setSelectedComponent(null);
          setSelectedComponentDetail(null)
        }}
        addedComponent={[window.currentMenuActions?.component]}
        departmentId={currentDepartment?.id}
        onSuccessReplace={() => { 
          updateList(); 
          setSelectedComponent(null);
          setSelectedComponentDetail(null)}}
        setExpandedIds={setExpandedIds}
        components={components}
      />
      <UninstallComponentModal
        componentIds={[window.currentMenuActions?.component?.id]}
        isOpen={isOpenUninstallComponentModal}
        isOpenManager={setIsOpenUninstallComponentModal}
        handleClose={() => {
          setIsOpenUninstallComponentModal(false);
        }}
        addedComponent={[window.currentMenuActions?.component]}
        departmentId={currentDepartment?.id}
        onSuccessReplace={updateList}
        setExpandedIds={setExpandedIds}
        components={components}
      />
      <AttachComponentModal
        isOpen={isOpenAttachComponentModal}
        handleClose={() => {
          setIsOpenAttachComponentModal(false);
          setAttachModalMode("attach");
          setSelectedComponent(null);
          setSelectedComponentDetail(null);
        }}
        departmentId={currentDepartment?.id}
        selectedComponent={window.currentMenuActions?.component}
        components={components}
        onSuccessAttach={(attachedComponent, parentComponent) => {
         
          window.lastAttachTime = Date.now();
          
          if (parentComponent?.id) {
            setOpenedComponentsIds(prevIds => {
              if (!prevIds.includes(parentComponent.id)) {
                return [...prevIds, parentComponent.id];
              }
              return prevIds;
            });
          }
          
          frozenComponentsRef.current = null;
          permanentCacheRef.current = null;
          listTreeCache.current = null;
          listTreeCacheKey.current = null;
          expandedListCache.current = null;
          expandedListCacheKey.current = null;
          
          updateList();
          setAttachModalMode("attach");
          setSelectedComponent(null);
          setSelectedComponentDetail(null);
        }}
        isOpenManager={setIsOpenAttachComponentModal}
        mode={attachModalMode}
      />
      <CloneToEquipmentModal
        isOpen={isOpenCloneToEquipmentModal}
        isOpenManager={setIsOpenCloneToEquipmentModal}
        ids={[window.currentMenuActions?.component?.id]}
        departmentId={currentDepartment?.id}
        instance={"components"}
      />
      <DeleteItemModal
        isOpen={isOpenDeleteModal}
        isOpenManager={setIsOpenDeleteModal}
        message={translation.removeComponentModalMessageLabel}
        onDeleteModalClose={() => {
          onDeleteComponent();
        }}
      />
      <SaveActivityModal
        componentsOptions={componentsOptions}
        isOpen={isOpenSaveActivityModal}
        isOpenManager={setIsOpenSaveActivityModal}
        isCatalog={isCatalog}
        componentId={window.currentMenuActions?.component?.id}
        activity={selectedActivity}
        componentWorkHours={window.currentMenuActions?.component?.workhoursTotal}
        components={components}
        setComponents={setComponents}
        useLocalTreeState
        onSuccessSave={handleActivitySaved}
        hideCompleted={!!selectedActivity}
        setSelectedComponentDetail={setSelectedComponentDetail}
      />
      <CompleteActivityModal
        employeesOptions={employeesOptions}
        isOpen={isOpenCompleteActivityModal}
        isOpenManager={setIsOpenCompleteActivityModal}
        activity={selectedActivity}
        employees={departmentEmployees}
        handleCompleteUpdate={async () => {
          try {
            const response = await MmsService.getComponents(
              currentDepartment.id
            );
            setIsLoading(false);
            setComponents(normalizeNestedToFlatList(response.data));
          } catch (error) {
            setIsLoading(false);
            if (
              error &&
              error.response &&
              error.response.data &&
              error.response.data.message
            )
              AlertToastr.showErrorAlert(error.response.data.message);
          }
        }}
      />
      <DeleteItemModal
        isOpen={isOpenDeleteActivityModal}
        isOpenManager={setIsOpenDeleteActivityModal}
        message={translation.removeActivityModalMessageLabel}
        onDeleteModalClose={() => {
          onDeleteActivity();
        }}
      />

      {!isCatalog && (
        <RecommendedSparePartsComponentBlock
          rspSelectedComponentsIds={selectedComponentsIds}
        />
      )}
      {currentDepartment && (
        <MmsAssetsSignalR
          departmentId={currentDepartment?.id}
          onIncomingData={handleLiveData}
          token={token}
          companyId={currentCompany?.id}
        />
      )}
      
      <HealthCheckSettings
        open={isOpenHealthCheckSettingsModal}
        handleClose={() => setIsOpenHealthCheckSettingsModal(false)}
        componentId={window.currentMenuActions?.component?.id}
      />
    </>
  );
}

const mapStateToProps = ({ mms, dashboard }) => ({
  currentCompany: dashboard.currentCompany,
  currentDepartment: mms.currentDepartment,
  runComponentsUpdate: mms.runComponentsUpdate,
  componentsCatalog: mms.componentsCatalog,
  employees: mms.employees,
})

const mapDispatchToProps = {
  setCurrentPage,
  setRunComponentsUpdate,
  setComponentsCatalog,
  setPageTitle,
  setRspSelectedComponentsIds,
}

export default connect(mapStateToProps, mapDispatchToProps)(EquipmentComponent)

